/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { GamaRoleConfig } from '../../models/gama-role-config';

export interface GetGamaRoleConfig$Params {
}

export function getGamaRoleConfig(http: HttpClient, rootUrl: string, params?: GetGamaRoleConfig$Params, context?: HttpContext): Observable<StrictHttpResponse<GamaRoleConfig>> {
  const rb = new RequestBuilder(rootUrl, getGamaRoleConfig.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<GamaRoleConfig>;
    })
  );
}

/**
 * Custom addition for our mocking infrastructure
 * in case this ever causes problems we can also keep a dictionary that maps operations to paths on the side
 **/
getGamaRoleConfig.PATH = '/api/gamaroleconfig';
getGamaRoleConfig.METHOD = 'get';

/**
 * we annotate each endpoint with a root rootUrl
 * this is because we have multiple APIs so we need to know which api fn belongs to
 * so we can map it depending on the env. rootUrl is picked from the first server listed in the APISpec
 **/
getGamaRoleConfig.ROOTURL = '/portal';
